import { render, staticRenderFns } from "./translations.vue?vue&type=template&id=784d328a"
import script from "./translations.vue?vue&type=script&lang=js"
export * from "./translations.vue?vue&type=script&lang=js"
import style0 from "./translations.vue?vue&type=style&index=0&id=784d328a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports